"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var axios_1 = __importDefault(require("axios"));
var auth_header_1 = __importDefault(require("./auth-header"));
var response_errors_1 = __importDefault(require("./response-errors"));
var localization_1 = require("../helpers/localization");
axios_1.default.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
axios_1.default.defaults.headers.common['Accept-Language'] = localization_1.getLanguage();
/**
 * Add X-CSRF-TOKEN to axios headers
 */
var token = document.head.querySelector('meta[name="csrf-token"]');
if (token) {
    axios_1.default.defaults.headers.common['X-CSRF-TOKEN'] =
        token.getAttribute('content');
}
else {
    console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token');
}
auth_header_1.default();
response_errors_1.default();
